import React, {PureComponent} from 'react'
import CSSModules from 'react-css-modules'
import Textarea from 'react-textarea-autosize'
import Isvg from 'react-inlinesvg'
import PropTypes from 'prop-types'

import makeUniqueId from 'helpers/makeUniqueId'
import textTransform from 'helpers/textTransform'
import VirtualKeyboardFull from 'components/virtual_keyboard_full/VirtualKeyboardFull'
import ClickOutside from 'decorators/click_outside/click_outside_decorator'

import styles from './InputTile.scss'

import ThumbnailDeleteIcon from 'assets/global/delete-btn.svg'

class InputTile extends PureComponent {

	constructor() {
		super()
		this.textareaId = makeUniqueId()
		this.state = {
			focused: false,
			selectionStart: 0,
			selectionEnd: 0,
			mode: 'normal',
		}
	}

	mathSymbolsToggle = open => {
		this.setState({
			mode: open ? 'normal' : this.state.mode,
		})
		this.element.focus()
		this.element.setSelectionRange(
			this.state.selectionStart,
			this.state.selectionEnd
		)

	}

	onFocus = () => {
		this.setState({
			focused: true,
		})
	}

	onBlur = () => {
		this.setState({
			focused: false,
		})
	}

	focus = () => {
		this.element.focus()
	}

	mathSymbolsContainerClickHandler = () => {
		this.element.focus()
		this.element.setSelectionRange(
			this.state.selectionStart,
			this.state.selectionEnd
		)
	}

	onChangeHandler = ev => {
		let value

		if (this.pasting === false) {
			if (this.state.mode === 'normal') {
				value = ev.target.value
			} else {
				const replacedText = this.props.value.substr(
					0,
					this.state.selectionStart
				) + this.props.value.substr(this.state.selectionEnd)
				value = textTransform(
					replacedText,
					ev.target.value,
					this.state.selectionStart,
					this.state.modeProvider
				)
			}

			if (this.props.value !== value) {
				this.props.changeTextHandler(value)
			} else {
				this.forceUpdate()
			}
		} else {
			this.props.changeTextHandler(ev.target.value)
			this.pasting = false
		}
	}

	onSelectionChangeHandler = () => {
		this.setState({
			selectionEnd: this.element.selectionEnd,
			selectionStart: this.element.selectionStart,
		})
	}

	mathSymbolChangeHandler = symbol => {
		if (!symbol.mode) {
			this.setState({
				mode: 'normal',
			})
			const selectionStart = this.state.selectionStart
			const selectionEnd = this.state.selectionEnd
			const currentValue = this.props.value
			const newValue = currentValue.substring(0, selectionStart)
				+ symbol.returns
				+ currentValue.substring(selectionEnd, currentValue.length)
			if (newValue.length <= this.props.maxLength) {
				this.props.changeTextHandler(newValue)
			}
		} else {
			this.setState({
				mode: symbol.mode===this.state.mode?'normal':symbol.mode,
				modeProvider: symbol.provider,
			})
		}
	}

	onClickOutsideHandler = () => {
		this.setState({
			mode: 'normal',
			focused: false,
		})
	}

	render() {
		return (
			<div styleName='InputTile'>
				{!this.state.focused && <label
					htmlFor={this.textareaId}
					styleName='InputTile-label'
				></label>}
				<div styleName='InputTile-bar'>
					{this.props.discardContentHandler &&
							<button styleName='InputTile-bar-delete' onClick={this.props.discardContentHandler}>
								<Isvg src={ThumbnailDeleteIcon} cacheGetRequests={true} styleName='InputTile-bar-delete-icon' />
							</button>
					}
				</div>
				<ClickOutside clickOutsideHandler={this.onClickOutsideHandler}>
					<div>
						<Textarea
							styleName='InputTile-text'
							onChange={this.onChangeHandler}
							inputRef={elem => {
								this.element=elem
							}}
							onFocus={this.onFocus}
							onBlur={this.onBlur}
							maxLength={this.props.maxLength}
							maxRows={8}
							value={this.props.value}
							onSelect={this.onSelectionChangeHandler}
							id={this.textareaId}
						/>
						<div styleName='InputTile-virtual-keyboard-wrapper'>
							<VirtualKeyboardFull
								mode={this.state.mode}
								onChange={this.mathSymbolChangeHandler}
								onContainerClick=
									{this.mathSymbolsContainerClickHandler}
								onToggle= {
									this.mathSymbolsToggle
								}
							/>
						</div>
					</div>
				</ClickOutside>
				<span styleName='InputTile-counter'>{this.props.maxLength - this.props.value.length}</span>
			</div>

		)
	}
}

InputTile.propTypes = {
	maxLength: PropTypes.number,
	value: PropTypes.string,
	discardContentHandler: PropTypes.func,
	changeTextHandler: PropTypes.func,
}

InputTile.defaultProps = {
	maxLength: 200,
	value: '',
	discardContentHandler: () => {},
	changeTextHandler: () => {},
}

export default CSSModules(InputTile, styles, { allowMultiple: true })
